export const FETCH_APPLICATIONS_REQUEST = 'APPLICATIONS/FETCH_APPLICATIONS_REQUEST';
export const FETCH_APPLICATIONS_SUCCESS = 'APPLICATIONS/FETCH_APPLICATIONS_SUCCESS';
export const FETCH_APPLICATIONS_FAILURE = 'APPLICATIONS/FETCH_APPLICATIONS_FAILURE';
